// @ts-nocheck
import { mixins } from 'sonata-react-components';
import styled from 'styled-components';

type Props = {
  multipleMap: boolean;
};

type LegendProps = {
  hasScroll: boolean;
};

export const MapViewStyled = styled.article<Props>`
  display: flex;
  flex-direction: column;
  width: ${props => (props.multipleMap ? '50%' : '100%')};

  .mapView {
    &__container {
      display: flex;
      width: 100%;
      height: 600px;
      box-shadow: 0 -1.3px 13px 0 rgba(18, 22, 30, 0.05);
    }

    &__leftContainer {
      display: flex;
      flex-direction: column;
      width: 100%;
    }

    &__map {
      height: 100%;
      max-height: 530px;
      width: 100%;
      position: relative;
    }

    &__legends {
      align-items: center;
      background-color: #191E21;
      display: flex;
      height: 72px;
      padding: 12px 16px;

      .mapView__legends-container {
        flex: 1;
      }
    }

    &__ranking {
      height: 100%;

      .reportingInsightsItem {
        width: 100%;
      }
    }
  }
`;

export const LegendsScroll = styled.div<LegendProps>`
  overflow-y: hidden;
  overflow-x: auto;
  ${mixins.forceScrollbar}
  padding-bottom: ${props => (props.hasScroll ? '8px' : '0px')};
  &::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.3);
  }
`;
